import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 2",
  viewBox: "0 0 56.36 42.38"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"17.61\" cy=\"10.86\" r=\"10.86\" class=\"i-332317394__cls-2\"></circle><path d=\"M29.79 42.38H5.44c-3.49 0-6.07-3.24-5.3-6.64 1.85-8.13 6.77-12.55 9.07-14.22 2.31 1.83 5.23 2.92 8.41 2.92s6.09-1.1 8.41-2.92c2.3 1.67 7.22 6.09 9.07 14.22.77 3.4-1.81 6.64-5.3 6.64Z\" class=\"i-332317394__cls-2\"></path><rect width=\"26.28\" height=\"4.21\" x=\"30.08\" class=\"i-332317394__cls-1\" rx=\"2.11\" ry=\"2.11\"></rect><rect width=\"21.48\" height=\"4.21\" x=\"34.89\" y=\"12.72\" class=\"i-332317394__cls-1\" rx=\"2.11\" ry=\"2.11\"></rect><rect width=\"15.87\" height=\"4.21\" x=\"40.49\" y=\"25.45\" class=\"i-332317394__cls-1\" rx=\"2.11\" ry=\"2.11\"></rect>", 5)
  ]))]))
}
export default { render: render }